import { Skeleton, Spin } from 'antd'
import { SpinWrapper } from 'modules/Drives/Style/style'
import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { categoryBasedStyle } from '../../../..'
import EmptyStateImage from '../../../../../../components/icons/EmptyState'
import { formatDateWithOrdinal } from '../../../../../../utils/commonFunction'
import EventCard from './EventCard'
import {
  Container,
  DateDisplay,
  EmptyStateContainer,
  HorizontalLine,
} from './style'

const UpcomingEvents = ({
  state,
  setState,
  fetchEventsList,
  listDate,
  handleSingleEventClick,
}) => {
  const fetchMoreData = async () => {
    let pageNo = state.pageNo + 1
    if (state?.eventListCurrentObj?.totalPage == pageNo) {
      setState(prevState => ({
        ...prevState,
        pageNo: prevState.pageNo + 1,
        hasMoreData: false,
      }))
      return
    }
    setState(prevState => ({
      ...prevState,
      pageNo: prevState.pageNo + 1,
      hasMoreData: true,
    }))
    fetchEventsList({ pageNo: pageNo, loadMore: true, from: listDate })
  }

  return (
    <>
      {state.loading ? (
        <SpinWrapper center>
          <Spin />
        </SpinWrapper>
      ) : state?.eventsList?.length === 0 ? (
        <EmptyStateContainer>
          <EmptyStateImage />
          No event available
        </EmptyStateContainer>
      ) : (
        <InfiniteScroll
          dataLength={state?.eventsList?.length}
          next={fetchMoreData}
          hasMore={state?.eventListCurrentObj?.totalPage !== (state?.eventListCurrentObj?.page + 1)}
          loader={
            state.hasMoreData ? (
              <Skeleton paragraph={{ rows: 2 }} active />
            ) : null
          }
          height={'60vh'}
        >
          {state?.eventFullList?.map(item => {
            return (
              <>
                <DateDisplay>
                  {item.date === 'noDate' ? ' ' :formatDateWithOrdinal(new Date(item.date))}
                </DateDisplay>
                {item?.eventsList?.map((item, index) => {
                  return (
                    
                      <Container key={index+"event"}>
                        <EventCard
                          variant="primary"
                          eventDay={item.eventDetails}
                          eventName={item.title}
                          eventCategoryText={item.className}
                          allDayEvent={item.allDayEvent}
                          isRegister={item.isRegister}
                          location={item?.location?.[0]}
                          categoryBasedObj={categoryBasedStyle(item.category)}
                          handleClick={() => handleSingleEventClick(item)}
                          selectedData={item}
                          startTime={item.startTime}
                          endTime={item.endTime}
                          isApplied={item?.studentEventMapping?.length > 0}
                          occurrence={state?.occurence == 'UPCOMING'}
                        />
                      </Container>
                   
                  )
                })}
                <HorizontalLine />
              </>
            )
          })}
        </InfiniteScroll>
      )}
    </>
  )
}
export default UpcomingEvents
